import http from '@/plugin/axios'
import Operation from '@utils/common/operation'
import Table from '@utils/table'
import Dialog from '@utils/common/dialog'

const dialogTable = new Table('orderpurchase.externalcontrol')
  .type('index')
  .sortable(false)
  .add('purchaseNo').width(180)
  .add('purchaseSeq')
  .add('purchasePhaseSeq')
  .add('qualifiedQty')
  .add('checkFrequency')
  .add('adddate').width(180)

function dialogTableApi(data: any) {
  return http({
    url: '/srmCheckApply/getCheckRecordPage',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data
  })
}

const dialog = new Dialog('orderpurchase.externalcontrol')
  .title('inspectionRecord')
  .isfooter(false)
  .table(dialogTable, {
    api: dialogTableApi,
    params: (row: any) => ({ checkApplyNo: row.checkApplyNo, seq: row.seq })
  })

function inspectionRecord(this: any, data: any) {
  dialog.open({ attrs: { row: data }})
}

const operation = new Operation('orderpurchase.externalcontrol')
  .width(130)
  .add('inspectionRecord').handle(inspectionRecord)

export default operation
